//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('travelWage', {
//        templateUrl: 'views/components/views/travelWage/travelWage.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'modalService', 'translateService', 'travelWageService', 'typeaheadService', function ($stateParams, stateService, modalService, translateService, travelWageService, typeaheadService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let travelWageId = $stateParams.travelwage_id;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                travelWageId: travelWageId,
//                edit: {},
//                selectListTravelWageTypes: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE CALLS

//            async function loadEdit() {
//                vm.model.edit = (await travelWageService.getTravelWage({ travelwage_id: travelWageId }))[0];
//            }
            
//            async function loadTravelWageTypes() {
//                vm.model.selectListTravelWageTypes = await travelWageService.listTravelWageTypes();
//            }

//            // #endregion LOAD PROCEDURE CALLS

//            // #region TYPEAHEAD SEARCH SINGLE PROCEDURE FUNCTION CALL

//            vm.typeaheadSearch = function (value, id) {
//                switch (id) {
//                    case 'account_name':
//                        vm.model.edit[id] = value;

//                        return typeaheadService.lookUpSearchAccounts({
//                            searchtext: vm.model.edit[id] || '',
//                            businessco_no: vm.model.edit.businessco_no
//                        });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion TYPEAHEAD SEARCH SINGLE PROCEDURE FUNCTION CALL

//            // #region SELECTED VALUE FUNCTION

//            vm.onTypeaheadSelected = function (item, id) {
//                switch (id) {
//                    case 'account_name':
//                        if (item) {
//                            vm.model.edit.account_no = item?.item_id ?? '0';
//                            vm.model.edit.account_name = item?.item_name ?? '';
//                        } else {
//                            vm.onTypeaheadClear('account_name');
//                        }
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion SELECTED VALUE FUNCTION

//            // #region CHANGED VALUE FUNCTION

//            vm.onTypeaheadChanged = function (value, item, id) {
//                switch (id) {
//                    case 'account_name':
//                        vm.model.edit.account_name = value;

//                        if (value) {
//                            if (item?.item_id) {
//                                vm.model.edit.account_no = item.item_id;
//                            }
//                        } else {
//                            vm.onTypeaheadClear('account_name');
//                        }
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion CHANGED VALUE FUNCTION

//            // #region CLEAR VALUE FUNCTION

//            vm.onTypeaheadClear = function (id) {
//                switch (id) {
//                    case 'account_name':
//                        vm.model.edit.account_no = '0';
//                        vm.model.edit.account_name = '';
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion CLEAR VALUE FUNCTION

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                travelWageService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                    		title: translations.error,
//                    		message: response[0].errormessage,
//                    		buttons: [{
//                    			label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: function (dialogItself) {
//                    				dialogItself.close();
//                    				vm.model.lockedSave = false;
//                    			}
//                    		}]
//                    	});
//                    } else {
//                    	vm.model.lockedSave = false;
//                    	stateService.back();
//                    }
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                translate();
//                loadEdit();
//                loadTravelWageTypes();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
